module.exports = __webpack_public_path__ + "img/home_ic_service.a7c92a8f.png";